import React from "react";
import Icon from "./Icon";
export default function Plus(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("line", {
    x1: "11",
    y1: "3",
    x2: "18",
    y2: "20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "11",
    y1: "3",
    x2: "4",
    y2: "20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "6",
    y1: "15",
    x2: "12",
    y2: "15"
  }));
}
Plus.displayname = "Plus";
//# sourceMappingURL=Word.js.map